
import InfoPageLayout from "./InfoPageLayout";
import ContentSection from "./ContentSection";

const termsData = [
  // {
  //   type: "p",
  //   content:
  //     'Last updated: [Date]. Please read these Terms and Conditions ("Terms") carefully before using the TimeWise application (the "Service") operated by Xenford ("us", "we", or "our").',
  // },
  {
    type: "p",
    content:
      "Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who wish to access or use the Service.",
  },

  { type: "h2", content: "1. Acceptance of Terms" },
  {
    type: "p",
    content:
      "By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you do not have permission to access the Service.",
  },

  { type: "h2", content: "2. User Accounts" },
  {
    type: "p",
    content:
      "When you create an account with us, you guarantee that you are above the age of 13, and that the information you provide us is accurate, complete, and current at all times. You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.",
  },

  { type: "h2", content: "3. User Conduct" },
  {
    type: "p",
    content:
      "As a condition of use, you promise not to use the Service for any purpose that is unlawful or prohibited by these Terms. You agree not to:",
  },
  {
    type: "ul",
    items: [
      "Use the Service in any way that could damage, disable, overburden, or impair any of our servers or the networks connected to any of our servers.",
      "Attempt to gain unauthorized access to any part of the Service, other accounts, computer systems, or networks connected to any of our servers.",
      "Reverse engineer, decompile, or disassemble any part of the Service.",
      'Use the Service to transmit any unsolicited or unauthorized advertising, promotional materials, "junk mail," "spam," or any other form of solicitation.',
    ],
  },

  { type: "h2", content: "4. Intellectual Property" },
  {
    type: "p",
    content:
      "The Service and its original content, features, and functionality are and will remain the exclusive property of Xenford and its licensors. The Service is protected by copyright, trademark, and other laws of both [Your Country] and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Xenford.",
  },

  { type: "h2", content: "5. Termination" },
  {
    type: "p",
    content:
      "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.",
  },

  { type: "h2", content: "6. Changes to Terms" },
  {
    type: "p",
    content:
      "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on this page. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.",
  },
];

const TermsAndConditions = () => {
  return (
    <InfoPageLayout
      title="Terms and Conditions"
      subtitle="The rules of engagement for using the TimeWise service."
    >
      <ContentSection data={termsData} />
    </InfoPageLayout>
  );
};

export default TermsAndConditions;
